import * as React from 'react';
import { ReactNode } from 'react';
import { getObjectValues, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { Input } from 'antd';
import {
	OWRadioDisplayWithIcons,
	OWRadioDisplayWithoutIcon,
} from '../visual_radio_input/VisualRadioInput';
import { MAX_OW_RADIO_TEXT_LENGTH } from '../../utils/DataConstants';

require('../visual_radio_input/VisualRadioInput.less');

interface OWAsyncRadioProps {
	placeholder?: string;
	valueAccessor?: any;
	records: any;
	outerStyle?: any;
	optionStyle?: any;
	size?: 'default' | 'large' | 'small';
	style?: any;
	fieldName: any;
	value?: any;
	onChange?: any;
	onClick?: any;
	loading?: boolean;
	disabled?: boolean;
	emptyWhenDisabled?: boolean;
	sortBy?: any;
	autoPickFirstOption?: any;
	sorter?: any;
	renderRecord(data: any): ReactNode;
	getDescription?(data: any): ReactNode;
}

export default class OWRadio extends React.Component<OWAsyncRadioProps, any> {
	constructor(props) {
		super(props);
		const value = props.value;
		this.state = {
			value: value,
			filteredRecords: [],
			searchText: '',
		};
	}
	s;

	componentDidMount(): void {
		this.setState(
			{
				filteredRecords: this.props.records,
			},
			() => {
				const { filteredRecords } = this.state;

				const {
					value,
					autoPickFirstOption = false,
					valueAccessor = (el) => el && el.id,
				} = this.props;
				if (
					!value &&
					autoPickFirstOption &&
					filteredRecords &&
					Object.keys(filteredRecords).length === 1
				) {
					this.triggerChange(valueAccessor(filteredRecords[Object.keys(filteredRecords)[0]]));
				}
			}
		);
	}
	componentDidUpdate(prevProps) {
		// Should be a controlled component.
		if (prevProps.value !== this.props.value || prevProps.records !== this.props.records) {
			this.setState({
				value: this.props.value,
				filteredRecords: this.props.records,
			});
		}
	}

	handleValueChange = (e) => {
		if (!('value' in this.props)) {
			this.setState({ value: e.target.value });
		}
		this.triggerChange(e.target.value);
	};

	handleSameValueClicked = (e) => {
		const { onClick } = this.props;
		if (nullSafeGet('target.value', e) == this.state.value && onClick) {
			onClick(e.target.value);
		}
	};

	triggerChange = (changedValue) => {
		// Should provide an event to pass value to Form.
		const onChange = this.props.onChange;
		if (onChange) {
			onChange(changedValue);
		}
	};

	handleSearch = (e) => {
		const searchText = e.target.value && e.target.value.trim();
		const { records } = this.props;
		const filteredRecords = !!searchText
			? Object.keys(records)
					.filter((_) => {
						const record = records[_];
						return nullSafeGetOrElse('name', record, '')
							.toLowerCase()
							.includes(searchText.toLowerCase());
					})
					.reduce((acc, id) => {
						return {
							...acc,
							[id]: records[id],
						};
					}, {})
			: records;
		this.setState({ searchText, filteredRecords });
	};

	render() {
		const { value } = this.state;
		const {
			fieldName,
			records,
			sorter = (records) => records.sort((a, b) => (a.name > b.name ? 1 : -1)),
			valueAccessor = (el) => el.id,
			renderRecord,
			optionStyle = { height: 228 },
			getDescription,
		} = this.props;
		const { filteredRecords } = this.state;
		const selectedVals = Array.isArray(value) ? value : [value];
		const selectedRecords = selectedVals
			.map((v) => records[v])
			.filter((r) => r && valueAccessor(r));
		const dropdownRecords = getObjectValues(filteredRecords);
		const visibleRecords = selectedRecords.concat(
			dropdownRecords.filter((r) => !selectedVals.some((val) => valueAccessor(r) == val))
		);
		const sortedVisibleRecords = sorter(visibleRecords);
		const canShowList = sortedVisibleRecords.some((record) => {
			const val = renderRecord(record);
			return nullSafeGetOrElse('length', val, 0) > MAX_OW_RADIO_TEXT_LENGTH;
		});
		return (
			<div className={canShowList ? 'radio-container-list-view' : ''}>
				{sortedVisibleRecords.length <= 8 &&
				(!this.state.searchText || this.state.searchText.length === 0) ? null : (
					<div style={{ paddingBottom: 16, textAlign: 'center' }}>
						<Input.Search size="large" style={{ width: 320 }} onChange={this.handleSearch} />
					</div>
				)}
				{sortedVisibleRecords.some((option) => option.icon) ? (
					<OWRadioDisplayWithIcons
						getDescription={getDescription}
						sortedVisibleRecords={sortedVisibleRecords}
						valueAccessor={valueAccessor}
						fieldName={fieldName}
						value={this.state.value}
						searchText={this.state.searchText}
						handleSameValueClicked={this.handleSameValueClicked}
						handleValueChange={this.handleValueChange}
						renderRecord={renderRecord}
						dropdownRecords={dropdownRecords}
						canShowList={canShowList}
					/>
				) : (
					<OWRadioDisplayWithoutIcon
						getDescription={getDescription}
						sortedVisibleRecords={sortedVisibleRecords}
						valueAccessor={valueAccessor}
						fieldName={fieldName}
						value={this.state.value}
						searchText={this.state.searchText}
						handleSameValueClicked={this.handleSameValueClicked}
						handleValueChange={this.handleValueChange}
						renderRecord={renderRecord}
						dropdownRecords={dropdownRecords}
						canShowList={canShowList}
					/>
				)}
			</div>
		);
	}
}
